import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        surveyGroup: '=',
        uibModalInstance: '=',
        company: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'survey.Edit general data' | translate }}</h2>
        </div>
        <div class="modal-body">
            <survey-form form="vm.form" forms="vm.forms" company="vm.company" save="vm.save()"/>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, FORMS_TYPE_ENUM, SURVEY_PARTICIPANT_STATUS_ENUM, MomentService, FormFactory, FormResource, SurveyService, ModalService, lodash) {
        this.$translate = $translate;
        this.SURVEY_PARTICIPANT_STATUS_ENUM = SURVEY_PARTICIPANT_STATUS_ENUM;
        this.MomentService = MomentService;
        this.FormFactory = FormFactory;
        this.ModalService = ModalService;
        this.SurveyService = SurveyService;
        this.forms = FormResource.query({ pageSize: 0, type: FORMS_TYPE_ENUM.KEYS.SURVEY });
        this.lodash = lodash;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.surveyGroup, { expand: 'formActiveI18n,sortedByNameParticipants,users,activeI18n,surveyGroupI18ns' });
        this.oldDeadline = this.MomentService.formatTimeStamp(this.surveyGroup.deadline, 'YYYY-MM-DD HH:mm:ss', true);
    }

    save () {
        if (this.showConfirmationWindow()) {
            let message = this.$translate.instant('survey.deadline_confirmation_message', {
                deadline: this.MomentService.format(this.form.model.deadline)
            });
            if (!this.form.model.deadline) {
                message = this.$translate.instant('survey.edit_no_deadline_confirmation_message');
            }

            this.ModalService.confirm(message, 'medium').then(() => {
                this.doSave(true);
            });
        }
        else {
            this.doSave();
        }
    }

    showConfirmationWindow () {
        if ((!this.oldDeadline && !this.form.model.deadline) || (this.oldDeadline === this.form.model.deadline)) {
            return false;
        }
        return this.lodash.filter(
            this.form.model.sortedByNameParticipants,
            ['status', [
                this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.NOT_COMPLETED,
                this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.NOT_STARTED
            ]]
        );
    }

    doSave () {
        this.form.save().then((updatedSurveyGroup) => {
            this.uibModalInstance.close(updatedSurveyGroup);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/survey/edit/index.js